"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedDomain = void 0;
const Observable_1 = require("./socket/Observable");
const User_1 = __importDefault(require("./user/User"));
const DomainEvents_1 = require("./utils/DomainEvents");
class AuthenticatedDomain {
    constructor(adapterFactory, config, internetStatusManager, organizationIdStorage, deviceTokenProvider) {
        this.domainType = "authenticated";
        this.user = null;
        this.isPasswordChangeRequired = false;
        this.isLoginError = false;
        this.changeListeners = [];
        this.removeListeners = [];
        this.internetStatusManager = internetStatusManager;
        this.adapterFactory = adapterFactory.withAuthStatusManager(this);
        this.authAdapter = adapterFactory.createAuthAdapter();
        this.httpAdapter = adapterFactory.createHttpAdapter(this.authAdapter, this.internetStatusManager);
        this.config = config;
        this.organizationIdStorage = organizationIdStorage;
        this.deviceTokenProvider = deviceTokenProvider;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.removeListeners.length > 0) {
                throw new Error("Panic: Listeners should have been destroyed during unmount!!!");
            }
            try {
                this.removeListeners.push(Observable_1.Observable.getInstance().subscribe(DomainEvents_1.SocketStatusEvents.DISCONNECTED_PENDING_RETRY, () => {
                    this.internetStatusManager.unknown();
                }));
                this.removeListeners.push(Observable_1.Observable.getInstance().subscribe(DomainEvents_1.SocketStatusEvents.ON_CHANGE, ({ isConnected }) => {
                    if (isConnected) {
                        // We are signalling possiblyOnline to allow internet to stabilize post socket connection - some sync API calls fail with No Internet error
                        this.internetStatusManager.unknown();
                    }
                    this.notifyChange();
                }));
                return yield this.checkUserAuthentication();
            }
            catch (error) {
                yield this.destroy();
                throw error;
            }
        });
    }
    destroy() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearListeners();
            if (this.user) {
                this.user.destroyOrgUsers();
            }
        });
    }
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("login => Already authenticated");
        });
    }
    forgotPassword() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("forgotPassword => Not allowed in authenticated state");
        });
    }
    resetPassword() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("resetPassword => Not allowed in unauthenticated state");
        });
    }
    setPassword() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("setPassword => Not allowed in unauthenticated state");
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.user) {
                this.user = new User_1.default(this.authAdapter, this.config, this.httpAdapter, this.adapterFactory);
                yield this.user.fetchOrganizations(this.internetStatusManager);
            }
            return this.user;
        });
    }
    checkUserAuthentication() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const isUserAuthenticated = yield ((_a = this.authAdapter) === null || _a === void 0 ? void 0 : _a.isAuthenticated());
            // Scenario 1 - User is not authenticated and user object is empty - Login - Do Nothing
            // Scenario 4 - User is not authenticated and user object is not empty - Token Expire - Logout
            // Scenario 2 - User is authenticated but user object is empty - Refresh Page - Create New User
            // Scenario 3 - User is authenticated and user object is not empty - User is loggedIn - Do Nothing
            if (!isUserAuthenticated && this.isUserLoggedIn()) {
                yield this.logoutUser();
                return false;
            }
            if (isUserAuthenticated && !this.user) {
                yield this.createUser();
            }
            return true;
        });
    }
    clearListeners() {
        this.removeListeners.forEach(removeListener => removeListener());
        this.removeListeners = [];
    }
    logoutUser() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.user) {
                const { user } = this;
                this.user = undefined;
                this.isPasswordChangeRequired = false;
                // Clear the device token BEFORE the session is torn down, so it goes out
                // with a still-attachable auth token. Covers force logout (401/403) too,
                // where no app-level handler runs. Best-effort — never block logout.
                yield this.clearDeviceTokenOnLogout();
                yield user.logOut();
                this.clearListeners();
                const unauthenticatedDomain = new (yield Promise.resolve().then(() => __importStar(require("./UnauthenticatedDomain")))).UnauthenticatedDomain(this.adapterFactory, this.config, this.internetStatusManager, this.organizationIdStorage, this.deviceTokenProvider);
                yield ((_a = unauthenticatedDomain.init) === null || _a === void 0 ? void 0 : _a.call(unauthenticatedDomain));
                this.notifyChange(unauthenticatedDomain);
            }
        });
    }
    unexpectedlyLostAccess() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.logoutUser();
        });
    }
    isUserLoggedIn() {
        return true;
    }
    registerChangeListener(cb) {
        this.changeListeners.push(cb);
        return () => {
            this.changeListeners = this.changeListeners.filter(listener => listener !== cb);
        };
    }
    subscribeToCrossTabAuthChanges(callback) {
        return this.authAdapter.subscribeToCrossTabAuthChanges(callback);
    }
    updateDeviceToken(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.getCommonAdapter().updateDeviceToken(requestData);
            }
            catch (e) {
                console.log("updateDeviceToken error:", e);
                throw e;
            }
        });
    }
    clearDeviceToken(deviceToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.getCommonAdapter().clearDeviceToken(deviceToken);
            }
            catch (e) {
                console.log("clearDeviceToken error:", e);
                throw e;
            }
        });
    }
    clearDeviceTokenOnLogout() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.deviceTokenProvider)
                return;
            try {
                const deviceToken = yield this.deviceTokenProvider();
                if (deviceToken) {
                    yield this.clearDeviceToken(deviceToken);
                }
            }
            catch (e) {
                console.log("clearDeviceTokenOnLogout error:", e);
            }
        });
    }
    createUser() {
        return __awaiter(this, void 0, void 0, function* () {
            this.user = new User_1.default(this.authAdapter, this.config, this.httpAdapter, this.adapterFactory);
            yield this.user.fetchOrganizations(this.internetStatusManager);
            this.notifyChange();
        });
    }
    notifyChange(replacementDomain) {
        const domainToNotify = replacementDomain || this;
        this.changeListeners.forEach(cb => cb(domainToNotify));
    }
}
exports.AuthenticatedDomain = AuthenticatedDomain;
